import { random } from 'lodash';
import Entry from './entry/Entry';
import Enemy from '../../enemy/Enemy';

const RANGE_X = 100;
const RANGE_Y = 100;

export default class Hit extends Phaser.GameObjects.Container {
    private entries: Entry[];

    constructor(scene: Phaser.Scene) {
        super(scene, 0, 0);
        this.scene.layers.vfx.add(this);

        this.entries = [];

        this.createAnims();
        this.setupListeners();
    }

    createAnims() {
        this.scene.anims.create({
            key: 'vfx_hit',
            repeat: 0,
            frames: this.scene.anims.generateFrameNames('atlas', {
                prefix: 'vfx/hit/frame_',
                start: 0,
                end: 13,
                zeroPad: 0,
            }),
        });
    }

    setupListeners() {
        this.scene.events.on(Enemy.EVENTS.DAMAGED, this.onEnemyDamaged, this);
    }

    onEnemyDamaged(x: number, y: number, damage: number, isCrit: boolean, isEnrageHit: boolean, heroId: number, isAura: boolean = false) {
        let entry = this.getEntry()!;
        x = random(x - RANGE_X, x + RANGE_X);
        y = random(y - RANGE_Y, y + RANGE_Y);

        entry.launch(x, y, isCrit, isEnrageHit, isAura);
    }

    getEntry() {
        let entry = null;
        if (this.entries.length === 0) {
            entry = new Entry(this.scene, 0, 0);
            entry.on('done', this.onEntryDone, this);
            this.add(entry);
        } else {
            entry = this.entries.pop()!;
            entry.activate();
        }
        return entry;
    }

    onEntryDone(entry: Entry) {
        entry.deactivate();
        this.entries.push(entry);
    }

    destroy() {
        this.scene.events.off(Enemy.EVENTS.DAMAGED, this.onEnemyDamaged, this);
        super.destroy();
    }
}
